// FILE: src/firebase.js — STABİL (login + upload çalışır)
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { initializeFirestore, memoryLocalCache, setLogLevel, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// FAZ 6 (6.5 bundle) — firebase/database importu KALDIRILDI: RTDB yalnız
// MyLive tarafından kullanılıyor ve MyLive zaten lazy chunk'ta; buradaki
// eager import SDK'yı (~35 kB gzip) her kullanıcının ana bundle'ına
// sokuyordu. Yeni konum: services/mylive/rtdbClient.js (lazy chunk içi).
// Analytics + messaging SDK'ları da dinamik import'a çevrildi (aşağıda).
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken as getAppCheckToken,
} from "firebase/app-check";
import type { AppCheck } from "firebase/app-check";
import { hataMesaji } from "./utils/hataAlani";

const firebaseConfig = {
  apiKey: "AIzaSyAKNCsetEkPBBhBoeJTexyrYygL96vzMRo",
  authDomain: "mylasa-final.firebaseapp.com",
  projectId: "mylasa-final",
  storageBucket: "mylasa-final.firebasestorage.app", // ✅ CORS derdi yok
  messagingSenderId: "574275313737",
  appId: "1:574275313737:web:2aff934186382ae8099f98", // App Check için zorunlu
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// Auth e-postaları (doğrulama/şifre sıfırlama) Türkçe şablondan gitsin —
// ayarlanmadığında varsayılan dile düşebiliyordu.
auth.languageCode = "tr";

// EMİR #35-REV — GÖZ görsel-test modu. KATMANLI İNERT-GUARD: yalnız hostname
// localhost/127.0.0.1 VE `?eye=1` iken aktifleşir. PROD HOST'TA (mylasa-final.web.app
// vb.) `?eye=1` verilse bile EYE_MODE=false kalır → prod davranışı SIFIR değişir.
// EYE_MODE'da: uygulama Firebase EMÜLATÖRÜNE bağlanır (auth+firestore), App Check
// atlanır, custom-token giriş hook'u açılır. Emülatör yalnız localhost'ta koşar →
// prod'da bağlanacak emülatör de yoktur (çift emniyet).
export const EYE_MODE = typeof window !== "undefined"
  && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)
  && new URLSearchParams(window.location.search).get("eye") === "1";

if (EYE_MODE) {
  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    import("firebase/auth").then(({ signInWithCustomToken, signOut }) => {
      (window as any).__eyeSignIn = (t: string) => signInWithCustomToken(auth, String(t));
      // GÖZ OTURUMSUZ SAHNE AİLESİ (#1019) — `__eyeSignIn`in simetriği.
      //
      // 📏 ÖLÇÜLEN KÖRLÜK: GÖZ her sahnede `__eyeSignIn` çağırdığı için
      // `App.tsx`in `if (!user) return <Auth />` dalı HİÇBİR karede
      // koşmuyordu → uygulamanın kullanıcıya ilk görünen ekranı
      // (giriş + kayıt) SIFIR görsel kapsamdaydı. Oturumu kapatmadan o
      // ekrana ULAŞILAMAZ: Firebase auth kalıcılığı sekme bağlamı boyunca
      // yaşar, yani "giriş yapmadan aç" demek "önce çık" demektir.
      //
      // 🔒 GÜVENLİK DELTASI SIFIR: bu satır `EYE_EMİR #35-REV`in KATMANLI
      // inert-guard'ının İÇİNDEDİR — yalnız hostname localhost/127.0.0.1
      // VE `?eye=1` iken tanımlanır. Üretim host'unda `EYE_MODE` false →
      // blok hiç çalışmaz, `window.__eyeSignOut` TANIMSIZ kalır.
      // Ayrıca yalnız oturum KAPATIR (yetki genişletmez).
      // ⚠️ `as any` DEĞİL, `as unknown as {…}`: `any-kapisi.js` cırcırı
      // explicit `any` sayısını dondurur ve ARTMASI kapıyı düşürür. Buradaki
      // dar şekil aynı işi yapar, tabanı kıpırdatmaz ve komşu satırlardan
      // daha DÜRÜSTTÜR (ne atandığını söyler).
      (window as unknown as { __eyeSignOut?: () => Promise<void> })
        .__eyeSignOut = () => signOut(auth);
      (window as any).__eyeReady = true;
    }).catch(() => { /* no-op */ });
  } catch { /* no-op */ }
}
// Faz12-FIX: Explicit memory cache — Firebase v10 varsayılan olarak IndexedDB
// persistent cache kullanır (getFirestore). Bu, silinen/expired mesajların
// cache'te kalmasına ve listener'ın yanlış count döndürmesine neden olur.
// (Örn: sunucuda 5 mesaj, cache'te 46 — listener 46 döner.)
// memoryLocalCache ile her sayfa yüklemesinde temiz başlatılır.
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
});
// EMİR #35-REV — GÖZ modunda Firestore emülatörüne bağla (yalnız localhost+?eye=1).
if (EYE_MODE) {
  try { connectFirestoreEmulator(db, "127.0.0.1", 8080); } catch { /* no-op */ }
}
// FAZ 6 (6.5) — rtdb artık buradan export edilmiyor; MyLive repo'ları
// services/mylive/rtdbClient.js kullanır (lazy chunk).

// ✅ Firestore internal console spam'ini kapat (permission-denied "Uncaught..." dahil) — her ortamda
try {
  setLogLevel("silent");
} catch {
  // no-op
}

// ✅ Tek ve doğru bucket (explicit veriyoruz)
export const storage = getStorage(app, "gs://mylasa-final.firebasestorage.app");

// ✅ Realtime Database initialized for MyLive matching/presence/signaling
// Not: UI'nın çağırdığı eski callable'lar europe-west3'teydi.
// Burayı değiştirmiyoruz ki mevcut akış bozulmasın.
export const functions = getFunctions(app, "europe-west3");

// ══════════════════════════════════════════════════════════════════════════
// EMİR #35-REV (TAMAMLAMA, 2026-08-23) — GÖZ MODUNDA CALLABLE'LAR DA EMÜLATÖRE
//
// ── ÖLÇÜLEN DELİK ───────────────────────────────────────────────────────
// EYE_MODE auth ve firestore'u emülatöre bağlıyordu, **functions'ı BAĞLAMIYORDU**.
// Sonucu sanal dünyada ölçüldü: `takip-degistir` eylemi 0/2 idi ve sebebi ne
// sürücü ne de üründü — `src/services/relationships.ts` takip/takibi-bırakmayı
// YALNIZ callable ile yazıyor (`followUserV3`/`unfollowUserV3`) ve o çağrı
// emülatöre değil ÜRETİM `europe-west3`e gidiyordu. Ağ ad-alanında egress
// olmadığı için istek hiç tamamlanmıyor, `useFollowState` iyimser durumu geri
// alıyor, düğme eski etiketine dönüyordu. (Aynı delik `openBlindBox`,
// `retrieveCandidates` vb. BÜTÜN callable yollarını kapsıyordu: dünyanın
// "sunucu yarısı" yalnız TETİKLEYİCİ yarısıydı.)
//
// ── VE BU YALNIZ BİR TEST BOŞLUĞU DEĞİL, BİR EMNİYET DELİĞİYDİ ──────────
// Kanonun kaydettiği sınıf: *"test altyapısı canlıya dokunmaz"* (fixture bir
// kez üretim CDN'ine trafik basmaya hazır hâlde bulunmuştu ve yalnız egress
// kapalı olduğu için KAZARA zararsızdı). Burada da aynı şekil: egress'i olan
// bir makinede `?eye=1` ile açılan bir GÖZ koşusu CANLI PROJENİN
// callable'larını çağırırdı. Bağlantı bu riski YAPISAL olarak kapatır.
//
// 🔒 Aynı ÇİFT emniyet: yalnız hostname localhost/127.0.0.1 VE `?eye=1`
// (EYE_MODE). Üretim host'unda EYE_MODE false → bu satır hiç çalışmaz.
// ══════════════════════════════════════════════════════════════════════════
if (EYE_MODE) {
  import("firebase/functions").then(({ connectFunctionsEmulator }) => {
    try { connectFunctionsEmulator(functions, "127.0.0.1", 5001); } catch { /* no-op */ }
  }).catch(() => { /* no-op */ });
}

// P6.2: App Check — ReCaptchaV3Provider
// FAZ A — Token warmup + observability fix.
//
// Sorun (FAZ 18.5'te enforcement off edilmesinin sebebi):
//   - reCAPTCHA Enterprise script async yükleniyor; init çağrısı geri
//     dönse bile token henüz hazır olmayabiliyordu.
//   - Önceki kod debug token'ı "|| true" ile her dev sayfa yüklemesinde
//     enable ediyordu. Bu, prod-benzeri staging'de yanlış davranışa yol
//     açıyor (debug token ile gelen istekler enforcement'ı bypass eder).
//   - getToken() sonucunu kimse beklemiyordu → ilk birkaç callable
//     "appcheck-token-missing" ile düşüyordu, kullanıcıda PERMISSION_DENIED.
//
// FAZ A çözümü:
//   1. Debug token YALNIZCA explicit env var ayarlıysa enable et
//      (yanlışlıkla prod-staging'i bypass etmesin).
//   2. Init'i bir promise ile sarmalayıp ilk getToken() çağrısını
//      tetikle — token cache'e girene kadar ilk write'lar bunu await
//      edebilsin.
//   3. Hatayı `console.error` (warn değil) ile logla, observability artsın.
//
// ÖNEMLİ: rules tarafında AppCheck enforcement hâlâ KAPALI (FAZ 18.5).
//   Bu fix sadece istemci tarafını sağlamlaştırır. Enforcement re-enable
//   ayrı bir faz'da (FAZ A sonrası 72h monitor → canary %10 → full).
// ARIZA-2026-06-11 → ÇÖZÜLDÜ 2026-06-29: Eski 403'ün sebebi reCAPTCHA v3
// anahtarının izinli ALAN ADLARI eksikliğiydi (token exchange reddediliyordu).
// Sahibi reCAPTCHA admin'de domainleri ekledi (mylasa.app, www.mylasa.app,
// mylasa.com, www.mylasa.com, mylasa-final.web.app, localhost) + Firebase
// App Check'te uygulamayı reCAPTCHA secret'ı ile KAYDETTİ ("Registered").
// Site key DEĞİŞMEDİ (zaten doğruydu) → tekrar AÇILDI.
//
// GÜVENLİ ENFORCEMENT SIRASI (sahibi, konsol):
//   1. (BU COMMIT) istemci token üretmeye başlar — enforcement HÂLÂ KAPALI,
//      yani token üretilmese bile istek geçer (kullanıcı kilitlenmez).
//   2. App Check → APIs sekmesi: Firestore + Cloud Functions "Monitor"
//      (Unenforced) → bir gün "verified requests %"i izle.
//   3. % yüksekse → "Enforce". Sonra callable'lardaki soft verifyAppCheck
//      hard-reject'e çevrilir (bot/sahte-hesap kapısı gerçekten kapanır).
const APPCHECK_ENABLED = true;
const RECAPTCHA_SITE_KEY = '6LcrsK4sAAAAAFQHvvtIpk6lNA1LshdwUP4q6Lc_';

let _appCheck: AppCheck | null = null;
// Warmup token promise'i: `.then(...)` dalları token metnini ya da null döner.
let _appCheckReady: Promise<string | null> | null = null;

if (typeof window !== 'undefined' && APPCHECK_ENABLED && !EYE_MODE) {
  try {
    // Debug token: yalnızca explicit `REACT_APP_APPCHECK_DEBUG_TOKEN` env
    // var değeri ayarlıysa enable. "|| true" pattern'i kaldırıldı —
    // staging build'lerin yanlışlıkla bypass etmesini önler.
    const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
    if (
      process.env.NODE_ENV !== 'production' &&
      typeof debugToken === 'string' &&
      debugToken.length > 0
    ) {
      // eslint-disable-next-line no-restricted-globals
      (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
    }
    _appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });

    // Token warmup — ilk write/callable bunu await edebilsin diye
    // promise olarak sakla. Hata olursa null'a düşer ama init succeeded
    // kabul edilir (rules enforcement off → istek geçer).
    _appCheckReady = getAppCheckToken(_appCheck, /* forceRefresh */ false)
      .then((res) => {
        if (!res || typeof res.token !== 'string' || res.token.length === 0) {
          // eslint-disable-next-line no-console
          console.warn('[APPCHECK] warmup returned empty token');
          return null;
        }
        return res.token;
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('[APPCHECK] token warmup failed:', err?.message || err);
        return null;
      });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[APPCHECK] init failed:', hataMesaji(e) || e);
    _appCheck = null;
    _appCheckReady = Promise.resolve(null);
  }
} else {
  _appCheckReady = Promise.resolve(null);
}

export const appCheck = _appCheck;

/**
 * AppCheck token hazır olana kadar bekler. Init başarısızsa veya
 * AppCheck kapalıysa null döner. Çağıranlar critical write öncesi
 * bunu await edip token varlığını teyit edebilir.
 *
 * @returns {Promise<string|null>}
 */
export function awaitAppCheckToken() {
  return _appCheckReady || Promise.resolve(null);
}

// 🔍 DEBUG: Firebase config logging
if (typeof window !== 'undefined') {
  (window as any).debugFirebaseConfig = () => {
    const config = app.options;
    return config;
  };
  // Auto-log on load
}

// ✅ Firebase Analytics — sadece production'da ve destekleniyorsa aktif
// FAZ 6 (6.5) — SDK dinamik import: prod dışında hiç yüklenmez, prod'da
// ana bundle yerine ayrı küçük chunk olarak gelir.
// Şekiller SDK'dan TÜRETİLDİ (elle yazılmadı); `import(...)` tip konumunda
// çalışma-zamanı importu üretmez — dinamik chunk ayrımı korunur.
let _analytics: import("firebase/analytics").Analytics | null = null;
let _logEventFn: typeof import("firebase/analytics").logEvent | null = null;
// RIZA DENETİMİ (12 Haz 2026) — analitik YALNIZ çerez rızası "accepted" ise
// init edilir (eskiden koşulsuzdu; "Reddet" fiilen hiçbir şeyi kapatmıyordu).
// Karar formatı: CookieConsentBanner.js (legacy düz string + {decision,ts}).
function cookieConsentAccepted() {
  try {
    const raw = window.localStorage?.getItem("mlv3.cookieConsent");
    if (!raw) return false;
    if (raw === "accepted") return true;
    if (raw === "rejected") return false;
    return JSON.parse(raw)?.decision === "accepted";
  } catch {
    return false;
  }
}
if (typeof window !== "undefined" && process.env.NODE_ENV === "production" && cookieConsentAccepted()) {
  import("firebase/analytics")
    .then(({ getAnalytics, logEvent, isSupported }) =>
      isSupported().then((supported) => {
        if (supported) {
          _analytics = getAnalytics(app);
          _logEventFn = logEvent;
        }
      }),
    )
    .catch(() => {});
}

// ─── FCM MESSAGING (Faz 1C Görev 7) ────────────────────────────────────────
// Browser-guard + feature-detect: messaging modülü yalnızca tarayıcıda ve
// SW desteği olan ortamlarda init edilir. Sunucu/SSR yanlışlıkla import ederse
// null döner — caller isMessagingReady() ile kontrol eder.
let _messaging: import("firebase/messaging").Messaging | null = null;
let _messagingInitPromise: Promise<import("firebase/messaging").Messaging | null> | null = null;

export function getMessagingInstance() {
  if (_messaging) return Promise.resolve(_messaging);
  if (_messagingInitPromise) return _messagingInitPromise;
  if (typeof window === "undefined") return Promise.resolve(null);

  _messagingInitPromise = (async () => {
    try {
      // FAZ 6 (6.5) — SDK dinamik import (ana bundle'dan çıktı).
      const { getMessaging, isSupported: isMessagingSupported } =
        await import("firebase/messaging");
      const supported = await isMessagingSupported();
      if (!supported) return null;
      _messaging = getMessaging(app);
      return _messaging;
    } catch (e) {
      try {
        // eslint-disable-next-line no-console
        console.warn("[MESSAGING] init failed:", hataMesaji(e) || e);
      } catch {}
      return null;
    }
  })();

  return _messagingInitPromise;
}

/**
 * MyLive event logger — Analytics yoksa sessizce geçer
 * @param {string} eventName
 * @param {object} params
 */
export function logMyLiveEvent(eventName: string, params: Record<string, unknown> = {}) {
  try {
    if (_analytics && _logEventFn) {
      _logEventFn(_analytics, eventName, params);
    }
    // Her zaman console'a da yaz (dev + prod debug)
  } catch (e) {
    // no-op
  }
}

export default app;
